import type { ReactNode } from "react";

export type SortDirection = "asc" | "desc";

export interface DataTableSort {
  id: string;
  direction: SortDirection;
}

export interface DataTableFilterOption {
  label: string;
  value: string;
}

export interface DataTableFilterConfig {
  id: string;
  label?: string;
  placeholder?: string;
  options: DataTableFilterOption[];
}

export interface DataTableColumn<T> {
  id: string;
  header: string;
  accessorKey?: keyof T;
  cell?: (row: T) => ReactNode;
  sortable?: boolean;
  align?: "left" | "center" | "right";
  className?: string;
  headerClassName?: string;
  /** Hide this column in the auto-generated mobile card */
  hideOnMobile?: boolean;
  /** Label shown in mobile card rows */
  mobileLabel?: string;
  /** Lower numbers appear first in mobile card */
  mobilePriority?: number;
}

export interface DataTableState {
  page: number;
  pageSize: number;
  search: string;
  sort?: DataTableSort;
  filters: Record<string, string>;
}

export interface DataTablePaginationMeta {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  from: number;
  to: number;
}

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50];
